(function () {
  if (window.__WYDE_KLAVIYO_VARIANT_SYNC__) return;
  window.__WYDE_KLAVIYO_VARIANT_SYNC__ = true;

  var SYNC_DELAY_MS = 350;

  function getThemeStrings() {
    return (window.theme && window.theme.strings) || {};
  }

  function isNotifyLabel(text) {
    var strings = getThemeStrings();
    var notify = (strings.notify_in_stock_label || '').toLowerCase();
    var value = String(text || '').trim().toLowerCase();
    if (!value) return false;
    if (notify && value === notify) return true;
    return value.indexOf('notify') !== -1 || value.indexOf('meddela') !== -1;
  }

  function isAddToCartLabel(text) {
    var strings = getThemeStrings();
    var addLabel = (strings.add_to_cart_label || '').toLowerCase();
    var value = String(text || '').trim().toLowerCase();
    if (!value) return false;
    if (addLabel && value === addLabel) return true;
    return (
      value.indexOf('add to cart') !== -1 ||
      value.indexOf('lägg till') !== -1 ||
      value.indexOf('varukorg') !== -1
    );
  }

  function closeKlaviyoBisModal() {
    var closeSelectors = [
      '.klaviyo-bis-close',
      '.klaviyo-bis-modal-close',
      '#klaviyo-bis-modal .close',
      '#klaviyo-bis-modal [aria-label="Close"]',
      '[class*="klaviyo-bis"] [class*="close"]'
    ];

    for (var i = 0; i < closeSelectors.length; i++) {
      var closeBtn = document.querySelector(closeSelectors[i]);
      if (closeBtn) {
        closeBtn.click();
        return;
      }
    }

    var modal =
      document.getElementById('klaviyo-bis-modal') ||
      document.querySelector('[id*="klaviyo-bis-modal"], [class*="klaviyo-bis-modal"]');

    if (modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[class*="klaviyo"][class*="overlay"]').forEach(function (overlay) {
      overlay.style.display = 'none';
    });

    document.body.classList.remove('klaviyo-bis-modal-open');
    document.body.style.overflow = '';
  }

  function syncBuyButton(button) {
    if (!button) return;

    var textEl = button.querySelector('[data-button-text]');
    if (!textEl) return;

    var text = textEl.textContent.trim();

    if (isNotifyLabel(text)) {
      button.classList.add('klaviyo-bis-trigger');
      button.type = 'button';
      button.disabled = false;
      return;
    }

    if (isAddToCartLabel(text)) {
      button.classList.remove('klaviyo-bis-trigger');
      button.type = 'submit';
      button.disabled = false;
      closeKlaviyoBisModal();
    }
  }

  function syncProductBuyButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-form__btn[name="add"]').forEach(syncBuyButton);
  }

  function scheduleSync() {
    window.clearTimeout(scheduleSync.timer);
    scheduleSync.timer = window.setTimeout(function () {
      syncProductBuyButtons();
    }, SYNC_DELAY_MS);
  }

  function bindVariantPicker(picker) {
    if (!picker || picker.getAttribute('data-wyde-klaviyo-sync') === '1') return;
    picker.setAttribute('data-wyde-klaviyo-sync', '1');
    picker.addEventListener('change', scheduleSync);
  }

  function init() {
    document.querySelectorAll('variant-picker').forEach(bindVariantPicker);

    if (!window.__WYDE_KLAVIYO_VARIANT_SYNC_OBSERVER__) {
      window.__WYDE_KLAVIYO_VARIANT_SYNC_OBSERVER__ = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches && node.matches('variant-picker')) bindVariantPicker(node);
            if (node.querySelectorAll) {
              node.querySelectorAll('variant-picker').forEach(bindVariantPicker);
            }
          });
        });
      });

      window.__WYDE_KLAVIYO_VARIANT_SYNC_OBSERVER__.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
